import { Address } from "../../models/address";
import { Email } from "../../models/email";
import { Party } from "../../models/party";
import { Phone } from "../../models/phone";

export namespace Parties
{
    export class PartyServicePartyUpdated
    {
        static readonly type="[Party Service] Party Updated";
        constructor(public payload: {party: Party}){}
    }


    export class PartyServiceAddressAdded
    {
        static readonly type="[Party Service] Address Added";
        constructor(public payload: {partyId: number, address: Address}){}
    }

    export class PartyServiceEmailAdded
    {
        static readonly type="[Party Service] Email Added";
        constructor(public payload: {partyId: number, email: Email}){}
    }

    export class PartyServicePhoneAdded
    {
        static readonly type="[Party Service] Phone Added";
        constructor(public payload: {partyId: number, phone: Phone}){}
    }

    export class PartyServiceAddressUpdated
    {
        static readonly type="[Party Service] Address Updated";
        constructor(public payload: {partyId: number, address: Address}){}
    }

    export class PartyServiceEmailUpdated
    {
        static readonly type="[Party Service] Email Updated";
        constructor(public payload: {partyId: number, email: Email}){}
    }

    export class PartyServicePhoneUpdated
    {
        static readonly type="[Party Service] Phone Updated";
        constructor(public payload: {partyId: number, phone: Phone}){}
    }

    export class PartyServiceAddressDeleted
    {
        static readonly type="[Party Service] Address Deleted";
        constructor(public payload: {partyId: number, address: Address}){}
    }


    export class PartyServiceEmailDeleted
    {
        static readonly type="[Party Service] Email Deleted";
        constructor(public payload: {partyId: number, email: Email}){}
    }

    export class PartyServicePhoneDeleted
    {
        static readonly type="[Party Service] Phone Deleted";
        constructor(public payload: {partyId: number, phone: Phone}){}
    }
}